import type { SharedDashboardLayout } from "./layoutApi";

/** Somente evidencia local para diagnostico; nao altera o layout exibido. */
export interface LayoutConfirmation {
  revision: string | null;
  exists: boolean;
}

export function confirmLayoutResponse(
  layout: SharedDashboardLayout,
  workspaceId: string,
  machineId: string,
  configVersion?: string | null,
): LayoutConfirmation | null {
  if (layout.workspaceId !== workspaceId || layout.machineId !== machineId ||
    layout.configVersion !== (configVersion?.trim() || null)) return null;
  if (typeof layout.exists !== "boolean" ||
    (layout.updatedAt !== null && (typeof layout.updatedAt !== "string" || !Number.isFinite(Date.parse(layout.updatedAt)))) ||
    (layout.exists && layout.updatedAt === null)) return null;
  return { revision: layout.updatedAt, exists: layout.exists };
}
